export const LOAN_STATUS_LABEL_ALL_INACTIVE_LOANS = "All Inactive Loans";
